import { Typography } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import { green } from "@mui/material/colors";
import useRiskAssessmentHistoryAcknowledgementRecipients from "../../hooks/queries/useRiskAssessmentHistoryAcknowledgementRecipients";

// AcknowledgementStatus enum: Sent=0, Viewed=1, Acknowledged=2.
const ACKNOWLEDGED = 2;
const PARTIAL_COLOUR = "#e0a12f";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        minWidth: 120,
    },
    track: {
        flex: 1,
        maxWidth: 100,
        height: 8,
        borderRadius: 4,
        backgroundColor: theme.palette.grey[200],
        overflow: "hidden",
    },
    fill: {
        height: "100%",
        borderRadius: 4,
    },
    count: {
        whiteSpace: "nowrap",
    },
    muted: {
        color: theme.palette.text.secondary,
    },
}));

// Per-occurrence acknowledged/total; fetches its own recipients (no bulk endpoint).
export default function RiskAssessmentHistorySharingCell({ riskAssessmentHistoryId }) {
    const classes = useStyles();
    const { data, isLoading } = useRiskAssessmentHistoryAcknowledgementRecipients(riskAssessmentHistoryId);

    const recipients = Array.isArray(data) ? data : [];
    const total = recipients.length;
    const acknowledged = recipients.filter((r) => r.status === ACKNOWLEDGED).length;

    if (isLoading)
        return (
            <Typography variant="caption" className={classes.muted}>
                …
            </Typography>
        );

    if (total === 0)
        return (
            <Typography variant="caption" className={classes.muted}>
                Not shared
            </Typography>
        );

    const percent = Math.round((acknowledged / total) * 100);
    const complete = acknowledged === total;

    return (
        <div className={classes.wrapper}>
            <div className={classes.track}>
                <div className={classes.fill} style={{ width: `${percent}%`, backgroundColor: complete ? green[500] : PARTIAL_COLOUR }} />
            </div>
            <Typography variant="body2" className={classes.count}>
                {acknowledged}/{total}
            </Typography>
        </div>
    );
}
